import React from "react"

import { ColorSAP, FONT_FAMILY, Typography } from "../../ontego-ui"
import { ArrowRight } from "../../ontego-ui/sap_icons"
import { Box } from "@mui/material"

const MenuCard = props => {
    const { label, icon, value, onClick } = props

    return (
        <Box
            sx={{
                userSelect: 'none',
                position: 'relative',
                width: 'fit-content',
                padding: '8px 16px',
                boxSizing: 'border-box',
                background: ColorSAP.secondary[10],
                border: `2px solid ${ColorSAP.secondary[20]}`,
                borderRadius: "8px",
                cursor: (onClick && typeof onClick !== 'undefined') ? 'pointer' : 'auto',
                transition: 'all 0.15s ease-in-out',
                "&:hover": {
                    border: (onClick && typeof onClick !== 'undefined') && `2px solid ${ColorSAP.secondary[30]}`,
                    background: (onClick && typeof onClick !== 'undefined') && ColorSAP.secondary[30],
                    transition: 'all 0.15s ease-in-out'
                }
            }}
            onClick={onClick}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <Box
                    sx={{
                        marginLeft: "-6px",
                        height: "40px",
                        "& svg": {
                            width: "40px",
                            height: "40px",
                            color: ColorSAP.secondary[80]
                        }
                    }}
                >
                    {icon}
                </Box>
                <Typography
                    fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_SEMIBOLD}
                    size={24}
                    color={ColorSAP.secondary[80]}
                    style={{ marginLeft: 6 }}
                >
                    {label}
                </Typography>
            </Box>
            <Box>
                <Typography
                    fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
                    size={48}
                    color={ColorSAP.secondary[80]}
                >
                    {value}
                </Typography>
            </Box>

            <Box
                sx={{
                    position: 'absolute',
                    bottom: "16px",
                    right: "16px",
                    "& svg": {
                        width: "40px",
                        height: "40px",
                        color: ColorSAP.secondary[60]
                    }
                }}
            >
                {(onClick && typeof onClick !== 'undefined') && (
                    <ArrowRight />
                )}
            </Box>
        </Box>
    )
}

export default MenuCard